"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy2"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdApollo = require("cccisd-apollo");
var _admin = require("../../../selectors/admin.js");
var _getImportantRespondentFields = _interopRequireDefault(require("../../../helpers/getImportantRespondentFields.js"));
var _respondentsByDeployment = _interopRequireDefault(require("./respondentsByDeployment.graphql"));
var _respondentsByGroup = _interopRequireDefault(require("./respondentsByGroup.graphql"));
var _respondentsFromResponses = _interopRequireDefault(require("./respondentsFromResponses.graphql"));
var _respondentIdsFromPawnIds = _interopRequireDefault(require("./respondentIdsFromPawnIds.graphql"));
var _UrlInfo = require("../UrlInfo");
var _RespondentForm = require("../RespondentForm");
var _form = _interopRequireDefault(require("../RespondentForm/form.js"));
var _LoggedPawnMessages = _interopRequireDefault(require("./renders/LoggedPawnMessages"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var AppDefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var RespondentTable = /*#__PURE__*/function (_React$Component) {
  _inherits(RespondentTable, _React$Component);
  var _super = _createSuper(RespondentTable);
  function RespondentTable() {
    var _this;
    _classCallCheck(this, RespondentTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isLoading: true,
      pawnIdPath: '',
      statusPath: '',
      userPath: '',
      query: '',
      variables: {}
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(prevProps) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(prevProps.cycle.deploymentId !== _this.props.cycle.deploymentId)) {
                  _context.next = 4;
                  break;
                }
                _context.next = 3;
                return _this.setState({
                  isLoading: true
                });
              case 3:
                _this.setCycleInfo();
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getColumns", function () {
      var _this$state = _this.state,
        pawnIdPath = _this$state.pawnIdPath,
        showLink = _this$state.showLink,
        statusPath = _this$state.statusPath,
        userPath = _this$state.userPath;
      var _this$props = _this.props,
        cycle = _this$props.cycle,
        project = _this$props.project,
        omitIdentifiableColumns = _this$props.omitIdentifiableColumns;
      var deploymentId = cycle.deploymentId,
        roleHandle = cycle.roleHandle;
      var individualPasscode = cycle.settings.individualPasscode;
      var appdefRoles = AppDefs.pawn.roles || [];
      var roleDef = appdefRoles.find(function (item) {
        return item.handle === cycle.roleHandle;
      }) || {};
      if (omitIdentifiableColumns) {
        var _importantFields = [];
        if (roleHandle === 'respondent') {
          _importantFields = (0, _getImportantRespondentFields["default"])({
            importantFields: _importantFields,
            project: project
          });
        }
        var _newImportantFields = _importantFields.filter(function (f) {
          return !f.identifiable;
        })
        // .filter(iF => !fields.some(f => f.importantPath === iF.path))
        .map(function (f) {
          return {
            name: "".concat(userPath, "important.").concat(f.path),
            label: f.label,
            sort: true,
            filter: true
          };
        });
        return [{
          name: "".concat(pawnIdPath, "pawnId"),
          label: 'System ID',
          sort: true,
          filter: true
        }].concat(_toConsumableArray(_newImportantFields), [{
          name: "".concat(statusPath, "startedAt"),
          label: 'Started On',
          sort: true,
          filter: true
        }, {
          name: "".concat(statusPath, "completedAt"),
          label: 'Completed',
          sort: true,
          filter: true
        }, {
          name: "".concat(userPath, "messageCount"),
          label: 'Messages Sent',
          sort: true,
          filter: true
        }]);
      }
      var fields = [{
        name: "".concat(userPath, "user.username"),
        label: 'Username',
        importantPath: 'user.username',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "user.firstName"),
        label: 'First Name',
        importantPath: 'user.firstName',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "user.lastName"),
        label: 'Last Name',
        importantPath: 'user.lastName',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "user.email"),
        label: 'E-mail',
        importantPath: 'user.email',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "user.phone"),
        label: 'Phone',
        importantPath: 'user.phone',
        sort: true,
        filter: true
      }];
      if (individualPasscode) {
        fields.splice(1, 0, {
          name: 'passcode',
          label: 'Passcode',
          importantPath: 'passcode',
          sort: true,
          filter: true
        });
      }
      var importantFields = (0, _get2["default"])(roleDef, 'importantFields') || [];
      if (roleHandle === 'respondent') {
        importantFields = (0, _getImportantRespondentFields["default"])({
          importantFields: importantFields,
          project: project
        });
      }
      var newImportantFields = importantFields.filter(function (iF) {
        return !fields.some(function (f) {
          return f.importantPath === iF.path;
        });
      });
      newImportantFields.forEach(function (f) {
        fields.push({
          name: "".concat(userPath, "important.").concat(f.path),
          label: f.label,
          sort: true,
          filter: true
        });
      });
      fields.push({
        name: "".concat(statusPath, "startedAt"),
        label: 'Started On',
        sort: true,
        filter: true
      }, {
        name: "".concat(statusPath, "completedAt"),
        label: 'Completed',
        sort: true,
        filter: true
      }, {
        name: "".concat(userPath, "messageCount"),
        label: 'Messages Sent',
        sort: true,
        filter: true,
        render: function render(_ref2) {
          var value = _ref2.value,
            row = _ref2.row;
          return /*#__PURE__*/_react["default"].createElement(_LoggedPawnMessages["default"], {
            deploymentId: deploymentId,
            pawnIdPath: pawnIdPath,
            row: row,
            userPath: userPath
          });
        }
      }, {
        name: 'actions',
        label: 'Actions',
        render: function render(_ref3) {
          var value = _ref3.value,
            row = _ref3.row;
          return _this.renderActionButtons(row);
        },
        hideInCsv: true
      });
      if (showLink) {
        fields.push({
          name: 'pawn.pawn.respondentHash',
          label: 'Personal Link',
          render: function render(_ref4) {
            var row = _ref4.row;
            return _this.getLinkFromRow(row);
          },
          hideInTable: true
        });
      }
      return fields;
    });
    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(row, values) {
        var pawnId, respondentId, pawnResponse, respondentResponse;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                pawnId = row.pawnId, respondentId = row.respondentId;
                _context2.next = 3;
                return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
                  pawn: pawnId
                }), (0, _RespondentForm.getParams)(values));
              case 3:
                pawnResponse = _context2.sent;
                if (!pawnResponse.data.errors) {
                  _context2.next = 7;
                  break;
                }
                (0, _cccisdNotification["default"])({
                  duration: 0,
                  message: 'Error',
                  type: 'danger',
                  data: pawnResponse.data.errors
                });
                return _context2.abrupt("return", Promise.reject(_objectSpread({}, pawnResponse.data.errors)));
              case 7:
                _context2.next = 9;
                return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeploymentRespondent.update', {
                  respondentId: respondentId
                }), (0, _RespondentForm.getParams)(values));
              case 9:
                respondentResponse = _context2.sent;
                if (!respondentResponse.data.errors) {
                  _context2.next = 13;
                  break;
                }
                (0, _cccisdNotification["default"])({
                  duration: 0,
                  message: 'Error',
                  type: 'danger',
                  data: respondentResponse.data.errors
                });
                return _context2.abrupt("return", Promise.reject(_objectSpread({}, respondentResponse.data.errors)));
              case 13:
                _context2.next = 15;
                return _this.table.loadData();
              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "renderActionButtons", function (row) {
      var cycle = _this.props.cycle;
      var _this$state2 = _this.state,
        canRemove = _this$state2.canRemove,
        showLink = _this$state2.showLink;
      var btnCount = [showLink, ['anon', 'known'].includes(cycle.type), canRemove].reduce(function (count, bool) {
        return bool ? count + 1 : count;
      }, 0);
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          minWidth: btnCount * 31
        }
      }, showLink && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Copy Link",
        type: "default"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn', 'btn-xs', 'btn-info', _style["default"].btn),
        onClick: function onClick() {
          return (0, _UrlInfo.setClipboardText)(_this.getLinkFromRow(row));
        }
      }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null))), ['anon', 'known'].includes(cycle.type) && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Edit",
          type: "default"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: (0, _classnames["default"])('btn', 'btn-xs', 'btn-success', _style["default"].btn)
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
        title: "Edit Respondent Info",
        render: function render(_ref6) {
          var closeModal = _ref6.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_form["default"], {
            onSubmit: /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values) {
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        values.pawnHash = row["".concat(_this.state.userPath, "pawn.pawnHash")];
                        _context3.next = 3;
                        return _this.onSubmit(row, values);
                      case 3:
                        closeModal();
                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));
              return function (_x4) {
                return _ref7.apply(this, arguments);
              };
            }(),
            forCycle: cycle,
            initialValues: _objectSpread({
              roleHandle: cycle.roleHandle
            }, (0, _RespondentForm.getValues)(row)),
            isEditing: true
          });
        }
      }), canRemove && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Remove",
        type: "default"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn', 'btn-xs', 'btn-danger', _style["default"].btn),
        onClick: _this.removeRespondentFunc([row.respondentId])
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))));
    });
    _defineProperty(_assertThisInitialized(_this), "getLinkFromRow", function (row) {
      return Boilerplate.url(_this.state.baseUri + row["".concat(_this.state.userPath, "pawn.respondentHash")]);
    });
    _defineProperty(_assertThisInitialized(_this), "getRowActions", function () {
      var actions = [];

      // "Send Message" button is smart enough to know how many rows are selected,
      // so we should show row-action checkboxes if the "Send Message" button is visible,
      // regardless of whether there are any row-actions or not
      //
      // TO-DO: Make "Send Message" into a row-action in addition to the button
      // so that this code is not confusing.
      actions.push({
        name: 'doNothing',
        title: '-- unselect all --',
        action: function action() {}
      });
      if (_this.state.canRemove) {
        actions.push({
          name: 'removeRespondents',
          title: 'Remove Respondent(s)',
          action: function () {
            var _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref8) {
              var selectedRows;
              return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      selectedRows = _ref8.selectedRows;
                      _context5.next = 3;
                      return _cccisdApollo.client.query({
                        query: _respondentIdsFromPawnIds["default"],
                        variables: {
                          pawnIds: selectedRows,
                          deploymentId: _this.props.cycle.deploymentId
                        }
                      }).then( /*#__PURE__*/function () {
                        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(res) {
                          var _res$data;
                          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  if (!((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.flows.deployment.respondentList)) {
                                    _context4.next = 3;
                                    break;
                                  }
                                  _context4.next = 3;
                                  return _this.removeRespondentFunc(res.data.flows.deployment.respondentList.map(function (r) {
                                    return r.respondentId;
                                  }))();
                                case 3:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4);
                        }));
                        return function (_x6) {
                          return _ref9.apply(this, arguments);
                        };
                      }());
                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }));
            function action(_x5) {
              return _action.apply(this, arguments);
            }
            return action;
          }()
        });
      }
      return actions;
    });
    _defineProperty(_assertThisInitialized(_this), "setCycleInfo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _this$props2, cycle, project;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this$props2 = _this.props, cycle = _this$props2.cycle, project = _this$props2.project;
              _context6.t0 = cycle.type;
              _context6.next = _context6.t0 === 'anon' ? 4 : _context6.t0 === 'known' ? 7 : _context6.t0 === 'group' ? 10 : 18;
              break;
            case 4:
              _context6.next = 6;
              return _this.setState({
                userPath: 'pawn.',
                pawnIdPath: '',
                statusPath: '',
                query: _respondentsFromResponses["default"],
                variables: {
                  deploymentId: cycle.deploymentId,
                  projectId: project.groupId
                }
              });
            case 6:
              return _context6.abrupt("break", 18);
            case 7:
              _context6.next = 9;
              return _this.setState({
                userPath: 'pawn.',
                statusPath: 'pawn.assignmentProgress.',
                pawnIdPath: '',
                query: _respondentsByDeployment["default"],
                variables: {
                  deploymentId: cycle.deploymentId,
                  projectId: project.groupId
                }
              });
            case 9:
              return _context6.abrupt("break", 18);
            case 10:
              if (!cycle.settings.closedRoster) {
                _context6.next = 15;
                break;
              }
              _context6.next = 13;
              return _this.setState({
                userPath: 'pawn.',
                statusPath: 'pawn.assignmentProgress.',
                pawnIdPath: '',
                query: _respondentsByDeployment["default"],
                variables: {
                  deploymentId: cycle.deploymentId
                }
              });
            case 13:
              _context6.next = 17;
              break;
            case 15:
              _context6.next = 17;
              return _this.setState({
                pawnIdPath: 'pawn.',
                statusPath: 'assignmentProgress.',
                userPath: '',
                query: _respondentsByGroup["default"],
                variables: {
                  deploymentId: cycle.deploymentId,
                  roleHandle: cycle.roleHandle
                }
              });
            case 17:
              return _context6.abrupt("break", 18);
            case 18:
              _context6.next = 20;
              return _this.setState({
                isLoading: false,
                showLink: !cycle.settings.requireLogin && !cycle.settings.requirePass,
                baseUri: cycle.settings.useEndpoint ? "survey/".concat(cycle.endpoint, "/") : "d/".concat(cycle.hash, "/"),
                canRemove: cycle.type === 'known' || cycle.type === 'group' && cycle.settings.closedRoster
              });
            case 20:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));
    _defineProperty(_assertThisInitialized(_this), "removeRespondentFunc", function (ids) {
      return function () {
        var cycle = _this.props.cycle;
        (0, _cccisdConfirm["default"])({
          message: 'Confirm Removal',
          description: 'Are you sure you want to remove this respondent?',
          confirmLabel: 'Yes',
          abortLabel: 'Cancel'
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          var response, message;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeploymentRespondent.destroy', {
                    deploymentId: cycle.deploymentId
                  }), {
                    deploymentRespondentIds: ids
                  });
                case 2:
                  response = _context7.sent;
                  if (!response.data.errors) {
                    _context7.next = 6;
                    break;
                  }
                  message = Object.keys(response.data.errors).join(' ');
                  return _context7.abrupt("return", Promise.reject({
                    title: message
                  }));
                case 6:
                  _context7.next = 8;
                  return _this.table.loadData();
                case 8:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        })));
      };
    });
    return _this;
  }
  _createClass(RespondentTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setCycleInfo();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state3 = this.state,
        isLoading = _this$state3.isLoading,
        pawnIdPath = _this$state3.pawnIdPath,
        query = _this$state3.query,
        variables = _this$state3.variables;
      if (isLoading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
        columns: this.getColumns(),
        query: query,
        rowKey: "".concat(pawnIdPath, "pawnId"),
        graphqlVariables: variables,
        rowActions: this.getRowActions(),
        ref: function ref(element) {
          _this2.table = element;
        }
      });
    }
  }]);
  return RespondentTable;
}(_react["default"].Component);
_defineProperty(RespondentTable, "propTypes", {
  cycle: _propTypes["default"].object,
  omitIdentifiableColumns: _propTypes["default"].bool,
  // from redux
  project: _propTypes["default"].object
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    project: (0, _admin.getCurrentProject)(state.assignment.admin, props)
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, null, null, {
  forwardRef: true
})(RespondentTable);
exports["default"] = _default;